import { render, staticRenderFns } from "./coderOutpatientDemographics.vue?vue&type=template&id=1b8789e6&"
import script from "./coderOutpatientDemographics.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports